import axios from '../../localAxios';
import { restoreWorkspaceFoldersURL } from '../workspacesURLs';

interface RestoreWorkspaceFoldersParams {
  workspaceId: string;
  workspaceFolderIds: string[];
}

export async function restoreWorkspaceFolders({
  workspaceId,
  workspaceFolderIds,
}: RestoreWorkspaceFoldersParams) {
  const url = restoreWorkspaceFoldersURL(workspaceId);
  return axios.put(url.href, { workspace_folder_ids: workspaceFolderIds });
}
